import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, filter, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { ApiError } from '../../models/common/api-error';
import { of } from 'rxjs';
import { CustomFieldsService } from '../../services/custom-fields.service';
import { customFieldsActions } from '.';
import { fromStore } from '..';

@Injectable({
  providedIn: 'root',
})
export class CustomFieldsEffects {
  constructor(
    private store$: Store,
    private actions$: Actions,
    private customFieldsService: CustomFieldsService,
  ) {}

  needCustomFields$ = createEffect(() =>
    this.actions$.pipe(
      ofType(customFieldsActions.needCustomFields),
      withLatestFrom(this.store$.select(fromStore.selectCustomFieldsState)),
      filter(([action, customFieldsState]) => {
        // Charge uniquement si les données ne sont pas déjà chargées et pas en cours de chargement
        return customFieldsState.entitiesCount === 0 && !customFieldsState.loading;
      }),
      map(([action]) => customFieldsActions.findAll({ vendorId: action.vendorId })),
    ),
  );

  findAll$ = createEffect(() =>
    this.actions$.pipe(
      ofType(customFieldsActions.findAll),
      withLatestFrom(this.store$),
      mergeMap(([action, store]) => {
        return this.customFieldsService.findAll(action.vendorId).pipe(
          map((response) =>
            customFieldsActions.findAllSuccess({
              customFields: response.data,
            }),
          ),
          catchError((error: ApiError) =>
            of(customFieldsActions.findError({ error: error.message })),
          ),
        );
      }),
    ),
  );
}
